{
  "familyId": "GET-GROOT-AFRONDEN",
  "questions": [
    {
      "id": "GET-GROOT-AFRONDEN-001",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "multiple_choice",
      "question": "Rond 3.847 af op honderdtallen.",
      "options": ["3.800", "3.900", "3.850", "4.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "afronden_honderdtallen",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Kijk naar het tientallencijfer in 3.847: dat is de 4. Is 4 kleiner dan 5? Ja — dus rond je naar beneden af. 3.847 → 3.800.",
        "solutionSteps": ["Kijk naar het tientallencijfer: de 4 in 3.847", "Is 4 kleiner dan 5? Ja", "Rond naar beneden af: 3.847 → 3.800"],
        "distractorExplanations": {
          "0": "Goed! Het tientallencijfer is 4 (kleiner dan 5), dus naar beneden: 3.800.",
          "1": "Je hebt naar boven afgerond. Maar het tientallencijfer is 4, en 4 is kleiner dan 5. Onthoud: kleiner dan 5 = naar beneden afronden.",
          "2": "Je hebt afgerond op tientallen in plaats van honderdtallen. Bij honderdtallen worden de tientallen én eenheden 0: 3.800.",
          "3": "Je hebt afgerond op duizendtallen. Maar de vraag vraagt honderdtallen. Kijk naar het tientallencijfer (4): 3.800."
        }
      }
    },
    {
      "id": "GET-GROOT-AFRONDEN-002",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "multiple_choice",
      "question": "Rond 6.752 af op tientallen.",
      "options": ["6.750", "6.760", "6.700", "6.800"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "afronden_tientallen",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Kijk naar het eenhedencijfer in 6.752: dat is de 2. Is 2 kleiner dan 5? Ja — dus rond je naar beneden af. 6.752 → 6.750.",
        "solutionSteps": ["Kijk naar het eenhedencijfer: de 2 in 6.752", "Is 2 kleiner dan 5? Ja", "Rond naar beneden af: 6.752 → 6.750"],
        "distractorExplanations": {
          "0": "Goed! Het eenhedencijfer is 2 (kleiner dan 5), dus naar beneden: 6.750.",
          "1": "Je hebt naar boven afgerond. Maar het eenhedencijfer is 2, en 2 is kleiner dan 5. Onthoud: kleiner dan 5 = naar beneden afronden.",
          "2": "Je hebt afgerond op honderdtallen in plaats van tientallen. Bij tientallen wordt alleen de eenheid 0: 6.750.",
          "3": "Je hebt afgerond op honderdtallen naar boven. Maar de vraag vraagt tientallen. Kijk naar het eenhedencijfer (2): 6.750."
        }
      }
    },
    {
      "id": "GET-GROOT-AFRONDEN-003",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "multiple_choice",
      "question": "Rond 2.456 af op honderdtallen.",
      "options": ["2.500", "2.400", "2.460", "2.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "afronden_honderdtallen_grens",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.7,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Kijk naar het tientallencijfer in 2.456: dat is de 5. Is 5 gelijk aan of groter dan 5? Ja — dus rond je naar boven af. 2.456 → 2.500. Onthoud: bij 5 altijd naar boven!",
        "solutionSteps": ["Kijk naar het tientallencijfer: de 5 in 2.456", "Is 5 gelijk aan of groter dan 5? Ja", "Rond naar boven af: 2.456 → 2.500", "Onthoud: bij 5 altijd naar boven!"],
        "distractorExplanations": {
          "0": "Goed! Het tientallencijfer is 5, en bij 5 of meer rond je naar boven af: 2.500.",
          "1": "Je hebt naar beneden afgerond. Maar het tientallencijfer is 5, en bij 5 of meer rond je naar boven af. Onthoud: 5 of meer = naar boven afronden.",
          "2": "Je hebt afgerond op tientallen in plaats van honderdtallen. Bij honderdtallen worden tientallen én eenheden 0: 2.500.",
          "3": "Je hebt afgerond op duizendtallen. Maar de vraag vraagt honderdtallen. Kijk naar het tientallencijfer (5): 2.500."
        }
      }
    },
    {
      "id": "GET-GROOT-AFRONDEN-004",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "multiple_choice",
      "question": "Rond 9.963 af op honderdtallen.",
      "options": ["10.000", "9.900", "9.960", "9.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "afronden_honderdtallen_overgang",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Kijk naar het tientallencijfer in 9.963: dat is de 6. Is 6 groter dan of gelijk aan 5? Ja — dus rond je naar boven af. 9.900 + 100 = 10.000. Let op: de 9 loopt door naar de duizendtallen!",
        "solutionSteps": ["Kijk naar het tientallencijfer: de 6 in 9.963", "Is 6 groter dan of gelijk aan 5? Ja", "Rond naar boven af: 9.900 + 100 = 10.000", "Let op: de 9 op de honderdtallenplek loopt door naar de duizendtallen!"],
        "distractorExplanations": {
          "0": "Goed! Het tientallencijfer is 6 (≥ 5), dus naar boven. 9.900 → 10.000 (de honderdtallen lopen over naar de duizendtallen).",
          "1": "Je hebt naar beneden afgerond. Maar het tientallencijfer is 6, en 6 is groter dan 5. Onthoud: 5 of meer = naar boven afronden. 9.963 → 10.000.",
          "2": "Je hebt afgerond op tientallen in plaats van honderdtallen. Bij honderdtallen worden tientallen én eenheden 0: 10.000.",
          "3": "Je hebt afgerond op duizendtallen naar beneden. Maar de vraag vraagt honderdtallen. Kijk naar het tientallencijfer (6): 10.000."
        }
      }
    },
    {
      "id": "GET-GROOT-AFRONDEN-005",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "fill_in",
      "question": "Rond 14.538 af op tientallen. Typ je antwoord (bv. 14.540).",
      "options": [],
      "correctAnswer": "14.540",
      "data": {
        "acceptedAnswers": ["14.540", "14540"],
        "caseSensitive": false,
        "placeholder": "bv. 14.540",
        "unit": ""
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 14530,
            "end": 14550,
            "min": 14530,
            "max": 14550,
            "step": 5,
            "markers": [
              { "value": 14538, "label": "14.538", "color": "blue" },
              { "value": 14530, "label": "14.530", "color": "gray" },
              { "value": 14540, "label": "?", "color": "gray" }
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op tientallen",
            "content": "Kijk naar het eenhedencijfer. Is dat 5 of meer → naar boven. Anders → naar beneden. 14.538: eenhedencijfer is 8 → naar boven → 14.540.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "afronden_tientallen_groot",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Kijk naar het eenhedencijfer in 14.538: dat is de 8. Is 8 groter dan of gelijk aan 5? Ja — dus rond je naar boven af. 14.538 → 14.540.",
        "solutionSteps": ["Kijk naar het eenhedencijfer: de 8 in 14.538", "Is 8 groter dan of gelijk aan 5? Ja", "Rond naar boven af: 14.538 → 14.540"]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-GROOT-AFRONDEN-CJ-001",
      "familyId": "GET-GROOT-AFRONDEN",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_afronden_basis",
      "questionType": "comparison_judge",
      "question": "Welk getal ligt het dichtst bij 4.000?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "3.847", "label": "drieduizend achthonderd zevenenveertig" },
            { "id": "b", "content": "4.123", "label": "vierduizend honderd drieëntwintig" },
            { "id": "c", "content": "3.512", "label": "drieduizend vijfhonderd twaalf" }
          ],
          "criterion": "het dichtst bij 4.000",
          "correctIndex": 1
        }
      },
      "options": [],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand tot een rond getal",
            "content": "Bereken het verschil tussen elk getal en 4.000. Het getal met het kleinste verschil ligt het dichtst bij. 4.000 − 3.847 = 153; 4.123 − 4.000 = 123; 4.000 − 3.512 = 488.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "afronden_afstand_vergelijken",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bereken het verschil tot 4.000 voor elk getal. 3.847 → 4.000 − 3.847 = 153. 4.123 → 4.123 − 4.000 = 123. 3.512 → 4.000 − 3.512 = 488. Het kleinste verschil is 123, dus 4.123 ligt het dichtst bij 4.000.",
        "solutionSteps": [
          "3.847 ligt 153 onder 4.000 (4.000 − 3.847 = 153)",
          "4.123 ligt 123 boven 4.000 (4.123 − 4.000 = 123)",
          "3.512 ligt 488 onder 4.000 (4.000 − 3.512 = 488)",
          "Vergelijk afstanden: 123 < 153 < 488",
          "4.123 ligt het dichtst bij 4.000"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}